import LinkEditorPlugin from './link-editor-plugin';
export default LinkEditorPlugin;